import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import axios from 'utils/axios';

import { actions as profileActions } from 'sagas/app/workers/workersProfileSaga';
import { actions as descriptionActions } from 'sagas/app/workers/profileUploadsSaga';
import { creator, errorMessageGenerator } from 'uwork-app-core';

/**
 * Constants
 */
const REQUEST = '@app/workers/workersprofile/personalinformation/REQUEST';
const SUCCESS = '@app/workers/workersprofile/personalinformation/SUCCESS';
const FAILURE = '@app/workers/workersprofile/personalinformation/FAILURE';
const RESET = '@app/workers/workersprofile/personalinformation/RESET';

/**
 * Initial state
 */
const initState = {
    loading: false,
    errorStatus: '',
    success: null
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */

// Reducer
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case REQUEST:
                draft.loading = true;
                draft.errorStatus = '';
                draft.success = null;
                break;
            case FAILURE:
                draft.loading = false;
                draft.errorStatus = payload;
                break;
            case SUCCESS:
                draft.loading = false;
                draft.success = true;
                break;
            case RESET:
                draft.loading = false;
                draft.success = null;
                draft.errorStatus = '';
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    reset: () => creator(RESET)
};

/**
 * Saga functions
 */
export const sagas = {
    *request({ payload }) {
        try {
            const { worker_id } = payload;
            const response = yield axios.put(`/workers/${worker_id}`, payload);
            yield put(
                descriptionActions.description_request({
                    worker_id: worker_id,
                    description: payload.description
                })
            );
            yield put(actions.success(response.data));
            yield put(profileActions.request(worker_id));
        } catch (e) {
            yield put(actions.failure(errorMessageGenerator(e)));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
